import { IconName } from 'enums/icon';
import { TestSelector } from 'enums/tests';
import { ThemeColors } from 'providers/Theme';
import { CSSProperties, SVGProps } from 'react';

export const defaultStyleImportance = {
  color: false,
  display: false,
  position: false,
  top: false,
  left: false,
};

export type StyleImportance = Partial<typeof defaultStyleImportance>;

export interface IconProps<T extends SVGSVGElement>
  extends Omit<SVGProps<T>, 'rotate'> {
  id?: string;
  /**
   * Color of the icon (for icons using currentColor)
   */
  color?: string;
  themeColor?: ThemeColors;
  /**
   * Selector string for e2e tests
   */
  dataTest?: TestSelector;
  /**
   * Classnames that can be applied to the icon
   */
  className?: string;
  /**
   * The icon to be displayed
   */
  name?: IconName;
  /**
   * Allows style properties to be set on the icon
   */
  style?: CSSProperties;
  /**
   * description - Will be added as a <desc> element - giving more information
   * to screen readers than the Title alone.
   */
  description?: string;
  /**
   * descriptionId - to be used in the aria-described by attr on the svg element
   * Screen reader support for the <desc> element by itself is poor - so this is
   * required along with the description prop or the <desc> won't be rendered.
   */
  descriptionId?: string;
  /**
   * interactive: indicates that the icon is interactive in some way (like a click).
   * Ensure that the svg role is set correctly.
   */
  interactive?: boolean;
  /**
   * semantic: if the icon is more than just making things look nice - but has
   * some sort of meaning, but is not interactive - then set this to true.  Otherwise
   * screen readers will ignore the icon and the user will miss important information.
   */
  semantic?: boolean;
  styleImportance?: StyleImportance;
  /**
   * title: if supplied will be added as a <Title> element - which is better supoorted
   * by screen readers than <desc>
   */
  title?: string;
  /**
   * href: the url to the extenrally reference svg file.
   * The structure of the link is:  `${publicPath}#${iconName}`
   */
  href?: string;

  forwardRef?: React.MutableRefObject<SVGSVGElement | null>;
}
